<div class="modal modal-md fade show" style="display: block;">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">Edit image details</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="close()">
                    <span aria-hidden="true">×</span>
                    <span class="sr-only">Close</span>
                </button>
			</div>
			<div class="modal-body text-start">



                <div class="text-start" *ngIf="image">
                    <label>Enter any text that should appear over the gallery image</label>
                    <textarea
                        class="form-control bordered mb-2"
                        placeholder="Image text...."
                        rows="2"
                        [(ngModel)]="image.text"
                        [ngModelOptions]="{standalone: true}"></textarea>

                    <div class="mb-2">
                        <a (click)="toggleValue('showNavButton')">
                            <i
                                class="toggle fa"
                                [ngClass]="{
                                'fa-toggle-on text-success': image.showNavButton,
                                'fa-toggle-off' : !image.showNavButton}"></i>
                                Show naviation button?
                        </a>
                    </div>

                    <div *ngIf="image.showNavButton">
                        <label>Enter button text</label>
                        <input type="text" class="form-control bordered mb-2" [(ngModel)]="image.linkText" />

                        <label>Select button colour</label>
                        <select class="form-control bordered mb-2" [(ngModel)]="image.navButtonClass">
                            <option [ngValue]="">Please select...</option>
                            <option [ngValue]="p.id" *ngFor="let p of buttonClasses">{{p.name}}</option>
                        </select>

                        <label>Which page should the button link to?</label>
                        <select class="form-control bordered mb-2" [(ngModel)]="image.linkPageId">
                            <option [ngValue]="0">Please select...</option>
                            <option [ngValue]="p.id" *ngFor="let p of pages">{{p.name}}</option>
                        </select>
                    </div>

                    <div class="mb-2">
                        <a (click)="toggleRepeatForAll()">
                            <i
                                class="toggle fa"
                                [ngClass]="{
                                'fa-toggle-on text-success': repeatForAll,
                                'fa-toggle-off' : !repeatForAll}"></i>
                                Make these changes on all gallery images?
                        </a>
                    </div>

                    <div class="mt-4 text-end">
                        <button type="button" class="btn btn-primary btn-round btn-sm" (click)="saveImageMeta(image)">
                            Save
                        </button>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show"></div>


